// #region dependencies
import AppLogoCmpMod from '@Components/app-logotype/app-logotype.cmp.js';
import AuthSvcMod from '@Services/Auth.svc.js';
import IntercomSvcMod from '@Services/Intercom.svc.js';
import QueuePromisesSvcMod from '@Services/QueuePromises.svc.js';
import ServiceProviderUserSvcMod from '@Services/ServiceProviderUser.svc.js';
import StorageSvcMod from '@Services/Storage.svc.js';
import UtilitySvcMod from '@Services/Utility.svc.js';
import LoginFormTpl from './login-form.html';
// #endregion
/**
 * @deprecated Unused since the Auth0 migration. Retained with the legacy user.login state;
 * no live path renders this component.
 */
const compConfig = {
	template: LoginFormTpl,
	controller: LoginFormController,
	bindings: {
		modalInstance: '<',
		resolve: '<',
	},
};
/** @ngInject */
function LoginFormController(
	$rootScope,
	$log,
	$q,
	$window,
	ServiceProviderUserService,
	StorageSvc,
	$state,
	AuthSvc,
	IntercomService,
	UtilitySvc,
	QueuePromisesSvc,
	REGEX,
	AUTH_EVENTS
) {
	const $ctrl = this;
	$ctrl.$onInit = () => {
		// bound vars
		// fixme: refactor to alert component
		$ctrl.showMsg = false;
		$ctrl.message = null;
		$ctrl.credentials = {};
		$ctrl.running = false;
		$ctrl.emailPattern = REGEX.email;
		const viewInfoUrl = $state.href('user.info', {topic: 'cookies'});
		$ctrl.cookiesMsg = `Your browser has cookies disabled. Make sure your cookies are enabled. Follow <a href="${viewInfoUrl}" role="button">instructions</a> to resolve issue.`;
		$ctrl.showPassword = false;
		$ctrl.user = {email: '', password: ''};
		// bound functions
		$ctrl.login = login;
		$ctrl.toggleShowPass = toggleShowPass;
		$ctrl.forgotPassword = forgotPassword;
		$ctrl.onChangeCredentials = onChangeCredentials;
		// initialization
		IntercomService.shutdown();
		getLastEmail();
		checkCookies();
	};
	$ctrl.$postLink = () => {
		UtilitySvc.focus('email');
	};

	function checkCookies() {
		$ctrl.cookiesDisabled = !UtilitySvc.areCookiesEnabled();
	}

	function getLastEmail() {
		$ctrl.user.email = StorageSvc.get('last_login_email') || null;
	}

	function onChangeCredentials() {
		$ctrl.showMsg = false;
	}

	// updater function to update buffered requests
	function doLogin(params) {
		const _errMsg = {display: 'Error login user'};
		const _def = $q.defer();
		ServiceProviderUserService.postLogin(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) _def.resolve(data.payLoad, data.session_token);
				if (data?.error) _def.reject(Object.assign(data.error, _errMsg));
			})
			.catch(err => _def.reject(Object.assign(err.data.error, _errMsg)));
		return _def.promise;
	}

	function login() {
		if ($ctrl.loginForm.$invalid) return false;

		$ctrl.running = QueuePromisesSvc.add();

		doLogin({
			email: $ctrl.user.email,
			password: $ctrl.user.password,
		})
			.then(handle_doLogin)
			.catch(handleRejection)
			.finally(() => {
				$ctrl.running = QueuePromisesSvc.subs();
			});
	}

	function handle_doLogin(res) {
		// store last email
		StorageSvc.set('last_login_email', res.email);

		// store user
		AuthSvc.setUser(res);

		// boot intercom
		IntercomService.boot();

		// if modal, close with data or emit logged in event
		if ($ctrl?.resolve?.data) {
			$ctrl.modalInstance.close({user: res, config: $ctrl.resolve.data});
		} else {
			$rootScope.$broadcast(AUTH_EVENTS.OCA_CONFIRMED, {user: AuthSvc.currentUser(), config: null});
		}
	}

	function handleRejection(response) {
		switch (response.code) {
			case 1272:
				$ctrl.showMsg = true;
				$ctrl.message = 'Service Provider account deactivated. Contact us';
				break;
			case 1252:
				$ctrl.showMsg = true;
				$ctrl.message = 'Wrong password/email entered.';
				break;
			case 1253:
				$ctrl.showMsg = true;
				$ctrl.message = 'You have entered invalid login credentials.';
				break;
			case 1254:
				$ctrl.showMsg = true;
				$ctrl.message = 'Your account is inactive, please contact your provider.';
				break;
			default:
				$ctrl.showMsg = false;
				break;
		}
		$log.error(response);
	}

	function toggleShowPass() {
		$ctrl.showPassword = !$ctrl.showPassword;
	}

	function forgotPassword() {
		$state.go('user.forgotPass');
	}
}
// login-form
let compMod = angular
	.module('mod.cmp.LoginForm', [
		AppLogoCmpMod,
		AuthSvcMod,
		IntercomSvcMod,
		QueuePromisesSvcMod,
		ServiceProviderUserSvcMod,
		StorageSvcMod,
		UtilitySvcMod,
	])
	.component('loginForm', compConfig);
export default (compMod = compMod.name);
